import { render, staticRenderFns } from "./orderdetails.vue?vue&type=template&id=f46cb316&scoped=true&"
import script from "./orderdetails.vue?vue&type=script&lang=js&"
export * from "./orderdetails.vue?vue&type=script&lang=js&"
import style0 from "./orderdetails.vue?vue&type=style&index=0&id=f46cb316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46cb316",
  null
  
)

export default component.exports